import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { ChecklistModel } from '../model/checklist.model';
import {ConfigModel} from '../model/config.model';


@Injectable()
export class ConfigService {

    path = '/config';
    id: number;

    constructor(private baseService: BaseService) {}

    getAll() {
        return this.baseService.get(this.path, '');
    }

    getVersion() {
        return this.baseService.get('/sync/system-config', '');
    }

    post(config: ConfigModel) {
        return this.baseService.post(this.path, '/', config);
    }

    put(config: ConfigModel) {
        return this.baseService.put(this.path, '/', config);
    }

    save(config: ConfigModel) {
        if (config.id) {
            return this.put(config);
        } else {
            return this.post(config);
        }
    }

    delete(id: number) {
        return this.baseService.delete(this.path, '/' + id)
    }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/config.service.ts